module.exports = __webpack_public_path__ + "img/circle_arraw.40cbc05c.png";